import { FC, SVGProps } from "react";
import { useMirrorTransform } from "src/i18n/direction";

const PlaneTakeoff: FC<SVGProps<SVGSVGElement>> = ({ transform, ...props }) => {
  const mirroredTransform = useMirrorTransform(transform as string | undefined);
  return (
    <svg
      fill="currentcolor"
      height="512"
      viewBox="0 0 24 24"
      width="512"
      {...props}
      transform={mirroredTransform}
    >
      <g clipPath="url(#clip0_11_4181)">
        <path
          d="m2.50003 19h18.99997v2h-18.99997zm19.56997-9.35999c-.21-.8-1.04-1.28-1.84-1.06l-5.31 1.41999-6.89997-6.42999-1.93.51 4.13997 7.16999-4.96997 1.33-1.97-1.54-1.45.39 2.59 4.49 16.56997-4.43c.81-.23 1.28-1.05 1.07-1.84999z"
        />
      </g>
    </svg>
  );
};

export default PlaneTakeoff;
